import { useState } from "react";
import { Mail, Youtube, Instagram, Send } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/contact", form);
      toast.success("Message sent — we'll be in touch soon.");
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch { toast.error("Could not send message."); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-20" data-testid="contact-page">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        <div>
          <div className="label-eyebrow mb-3">Contact</div>
          <h1 className="font-serif-display text-5xl text-white leading-tight">Let's <span className="italic text-[#D4AF37]">collaborate</span></h1>
          <p className="text-neutral-300 mt-6 leading-relaxed">
            Questions about a track, custom dashboard requests, or partnership opportunities? Drop us a note.
          </p>
          <div className="mt-10 space-y-4 text-sm text-neutral-300">
            <a href="mailto:hanson@hohvibes.com" className="flex items-center gap-3 hover:text-[#D4AF37]"><Mail size={18} className="text-[#D4AF37]" /> hanson@hohvibes.com</a>
            <a href="https://youtube.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#D4AF37]"><Youtube size={18} className="text-[#D4AF37]" /> youtube.com/@HOHVibes</a>
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-[#D4AF37]"><Instagram size={18} className="text-[#D4AF37]" /> @hoh_vibes</a>
          </div>
        </div>
        <form onSubmit={submit} className="luxury-card rounded-xl p-8 space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-xs tracking-widest uppercase text-neutral-400">Name</label>
              <input data-testid="contact-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2 rounded text-white text-sm" />
            </div>
            <div>
              <label className="text-xs tracking-widest uppercase text-neutral-400">Email</label>
              <input data-testid="contact-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2 rounded text-white text-sm" />
            </div>
          </div>
          <div>
            <label className="text-xs tracking-widest uppercase text-neutral-400">Subject</label>
            <input data-testid="contact-subject" required value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2 rounded text-white text-sm" />
          </div>
          <div>
            <label className="text-xs tracking-widest uppercase text-neutral-400">Message</label>
            <textarea data-testid="contact-message" required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="mt-2 w-full bg-black border border-white/15 focus:border-[#D4AF37] outline-none px-3 py-2 rounded text-white text-sm" />
          </div>
          <button data-testid="contact-submit" disabled={loading} className="btn-gold w-full py-3 rounded text-xs tracking-widest uppercase font-semibold inline-flex items-center justify-center gap-2">
            <Send size={14} /> {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
